module.exports = "/images/promotion.png?ee6bcdd42ed23dbfc217ca43397fb322";